import { render, staticRenderFns } from "./companyDrawer.vue?vue&type=template&id=b2c0f644&"
import script from "./companyDrawer.vue?vue&type=script&lang=js&"
export * from "./companyDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports